/* eslint-disable @typescript-eslint/quotes */
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, throwError } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { serverUrl } from "../serverUrl";
import { FileResponseModel } from "../model/FileResponseModel";
import { ApiUrls } from "../services/ApiUrls";
import { LotteryFormResponse } from "../model/LotteryFormResponse";
import { Data } from "@angular/router";
import { PanFileResponseModel } from "../model/PanFileResponseModel";
import { EBillingReportComponent } from "../secure/report_e_billing/report_e_billing.component";

import { EBillingReportModal } from "../model/report_e_billingModel";
import { ApplicantMobileNumberAndEmailModel } from "../model/ApplicantMobileNumberAndEmailModel";
import { UploadCorrespondence} from "../model/UploadCorresponceModel";
@Injectable({
  providedIn: "root",
}) 

export class AuditTrailService {
  constructor(private httpClient: HttpClient) {}

  // async loadAllAuditTrails() {
  //   const url = (await serverUrl) + "open/loadAllAuditTrails";
  //   return new Promise((resolve) => {
  //     this.httpClient
  //       .post(url, { responseType: "json" })
  //       .toPromise()
  //       .then((res) => {
  //         resolve(res);
  //       })
  //       .catch((resp: Response) => {
  //         resolve(resp);
  //       });
  //   });
  // }

  // async getNames() {
  //   const url = (await serverUrl) + "open/getNames";
  //   return new Promise((resolve) => {
  //     this.httpClient
  //       .post(url, { responseType: "JSON" })
  //       .toPromise()
  //       .then((res) => {
  //         resolve(res);
  //       })
  //       .catch((resp: Response) => {
  //         resolve(resp);
  //       });
  //   });
  // }

  getProfileDetailsReport(regId: any): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("regId", regId);
    return this.httpClient
      .post<any>(serverUrl + "open/getProfileDetailsReportV1", queryParams, {
        headers: new HttpHeaders().set(
          "Content-Type",
          "application/x-www-form-urlencoded;charset=utf-8"
        ),
      })
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          return throwError(err);
        }),
        catchError((err) => {
          return of(err);
        })
      );
  }

  getRecordsByCriteriaV2(
    name: any,
    panNumber: any,
    regId: any
  ): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("name", null);
    queryParams = queryParams.append("panNumber", panNumber);
    queryParams = queryParams.append("regId", regId);

    return this.httpClient
      .post<any>(serverUrl + "open/getRecordsByCriteriaV2", queryParams, {
        headers: new HttpHeaders().set(
          "Content-Type",
          "application/x-www-form-urlencoded;charset=utf-8"
        ),
      })
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          return throwError(err);
        }),
        catchError((err) => {
          return of(err);
        })
      );
  }

  // async getRecordsByCriteria(name: any, panNumber: any, regId: any) {
  //   const formData = new FormData();
  //   formData.append("name", null);
  //   formData.append("panNumber", panNumber);
  //   formData.append("regId", regId);
  //   const url = (await serverUrl) + "open/getRecordsByCriteriaV2";
  //   return new Promise((resolve) => {
  //     this.httpClient
  //       .post(url, formData)
  //       .toPromise()
  //       .then((res) => {
  //         resolve(res);
  //       })
  //       .catch((resp: Response) => {
  //         resolve(resp);
  //       });
  //   });
  // }

  // async downloadFile(documentPath: any) {
  //   const formData = new FormData();
  //   formData.append("documentPath", documentPath);
  //   const url = (await serverUrl) + "open/downloadFile";
  //   return new Promise((resolve) => {
  //     this.httpClient
  //       .post(url, formData, { responseType: "arraybuffer" as "json" })
  //       .toPromise()
  //       .then((res) => {
  //         resolve(res);
  //       })
  //       .catch((resp: Response) => {
  //         resolve(resp);
  //       });
  //   });
  // }

  downloadFileV1(documentPath: any, regId: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("documentPath", documentPath);
    queryParams = queryParams.append("regId", regId);
    return this.httpClient.post<any>(
      serverUrl + "open/downloadDocFile",
      queryParams,
      {
        headers: new HttpHeaders().set(
          "Content-Type",
          "application/x-www-form-urlencoded;charset=utf-8"
        ),
        responseType: "arraybuffer" as "json",
      }
    );
  }

  exportAuditTrailReportV1(panNumber: any): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("panNumber", panNumber);
    return this.httpClient.post<any>(
      serverUrl + "open/exportAuditTrailReport",
      queryParams,
      {
        headers: new HttpHeaders().set(
          "Content-Type",
          "application/x-www-form-urlencoded;charset=utf-8"
        ),
        responseType: "text" as "json",
      }
    );
  }

  exportAuditTrailApplication(
    autCategory: any,
    panNumber: any,
    regId: any
  ): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("autCategory", autCategory);
    queryParams = queryParams.append("panNumber", panNumber);
    queryParams = queryParams.append("registraitonId", regId);
    return this.httpClient.post<any>(
      serverUrl + "open/exportAuditTrailApplication",
      queryParams,
      {
        headers: new HttpHeaders().set(
          "Content-Type",
          "application/x-www-form-urlencoded;charset=utf-8"
        ),
        responseType: "text" as "json",
      }
    );
  }

  // async exportAuditTrailReport(panNumber: any) {
  //   const formData = new FormData();
  //   // formData.append("name", "null");
  //   formData.append("panNumber", panNumber);
  //   // formData.append("regId", "null");
  //   const url = (await serverUrl) + "open/exportAuditTrailReport";
  //   return new Promise((resolve) => {
  //     this.httpClient
  //       .post(url, formData, { responseType: "text" })
  //       .toPromise()
  //       .then((res) => {
  //         resolve(res);
  //       })
  //       .catch((resp: Response) => {
  //         resolve(resp);
  //       });
  //   });
  // }

  // async getReport(documentPath: any) {
  //   const formData = new FormData();
  //   // formData.append("name", "null");
  //   formData.append("documentPath", documentPath);
  //   // formData.append("regId", "null");
  //   const url = (await serverUrl) + "open/downloadFile";
  //   return new Promise((resolve) => {
  //     this.httpClient
  //       .post(url, formData)
  //       .toPromise()
  //       .then((res) => {
  //         resolve(res);
  //       })
  //       .catch((resp: Response) => {
  //         resolve(resp);
  //       });
  //   });
  // }

  getAuditTrail(autCategory: any, panNumber: any, regId: any): Observable<any> {
    // const formData = new FormData();
    // formData.append("autCategory", autCategory);
    // const url = (await serverUrl) + "open/getAuditTrail";
    // return new Promise((resolve) => {
    //   this.httpClient
    //     .post(url, formData)
    //     .toPromise()
    //     .then((res) => {
    //       resolve(res);
    //     })
    //     .catch((resp: Response) => {
    //       resolve(resp);
    //     });
    // });
    let queryParams = new HttpParams();
    queryParams = queryParams.append("autCategory", autCategory);
    queryParams = queryParams.append("panNumber", panNumber);
    queryParams = queryParams.append("registraitonId", regId);
    return this.httpClient.post<any>(
      serverUrl + "open/getAuditTrailApplication",
      queryParams,
      {
        headers: new HttpHeaders().set(
          "Content-Type",
          "application/x-www-form-urlencoded;charset=utf-8"
        ),
      }
    );
  }

  async getUsrChatV1(panNumber: string, regId: string) {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("panNumber", panNumber);
    queryParams = queryParams.append("registraitonId", regId);
    return this.httpClient.post<any>(
      serverUrl + "open/getUsrChatV1",
      queryParams,
      {
        headers: new HttpHeaders().set(
          "Content-Type",
          "application/x-www-form-urlencoded;charset=utf-8"
        ),
      }
    );
  }
  downloadLetters(applicationNo: string) {
    return this.httpClient.post<FileResponseModel>(
      ApiUrls.downloadLettersUrl.replace("{applicationNo}", applicationNo),
      null
    );
  }

  downloadCastValidityLetter(data: any) {
    console.log(data);
    return this.httpClient.post<FileResponseModel>(
      ApiUrls.downloadCastValidityLetterURLs
        .replace("{boardId}", data.board)
        .replace("{lotteryId}", data.lottery)
        .replace("{startDate}", data.startDate)
        .replace("{endDate}", data.endDate),
      null
    );
  }

  downloadApplicantDocs(data: any) {
    console.log(data);
    return this.httpClient.post<FileResponseModel>(
      ApiUrls.downloadApplicantDocsURLs
        .replace("{boardId}", data.board)
        .replace("{lotteryId}", data.lottery)
        .replace("{schemeId}", data.scheme),
      null
    );
  }

  downloadProjectTenement(board: any) {
    return this.httpClient.get<{
      status: string;
      errorMessage: string;
      data: string;
    }>(ApiUrls.downloadProjectTenementURLs.replace("{boardId}", board));
  }

  downloadProjectImages(projectId: any) {
    return this.httpClient.get<{
      status: string;
      errorMessage: string;
      data: string;
    }>(ApiUrls.downloadProjectImages.replace("{key}", projectId));
  }

  downloadApplicationReportCount() {
    return this.httpClient.post<{
      data: string;
      status: string;
      fileName: string;
      errorMessage: string;
    }>(ApiUrls.downloadApplicationCountReportURLs, {});
  }

  downloadWinnerApplicationReportList() {
    return this.httpClient.post<{
      data: string;
      status: string;
      fileName: string;
      errorMessage: string;
    }>(ApiUrls.downloadWinnerApplicationListReportURLs, {});
  }

  downloadWaitListApplicationReportList() {
    return this.httpClient.post<{
      data: string;
      status: string;
      fileName: string;
      errorMessage: string;
    }>(ApiUrls.downloadWaitListApplicationListReportURLs, {});
  }

  downloadNonWinnerApplicationReportList() {
    return this.httpClient.post<{
      data: string;
      status: string;
      fileName: string;
      errorMessage: string;
    }>(ApiUrls.downloadNonWinnerApplicationListReportURLs, {});
  }

  downloadTotalApplicationRecievedReportList() {
    return this.httpClient.post<{
      data: string;
      status: string;
      fileName: string;
      errorMessage: string;
    }>(ApiUrls.downloadTotalApplicationRecievedListReportURLs, {});
  }

  downloadEMDpaidApplicationReportList() {
    return this.httpClient.post<{
      data: string;
      status: string;
      fileName: string;
      errorMessage: string;
    }>(ApiUrls.downloadEMDPaidApplicationListReportURLs, {});
  }

  downloadVacantTenementReportList() {
    return this.httpClient.post<{
      data: string;
      status: string;
      fileName: string;
      errorMessage: string;
    }>(ApiUrls.downloadVacantTenementListReportURLs, {});
  }

  resetProfile(data: any) {
    console.log(">>>>>>>>>>>>>>>>>>>the Pan number is >" + data);
    return this.httpClient.post<FileResponseModel>(
      ApiUrls.resetProfileURLs.replace("{panNumber}", data.panNumber),
      // .replace('{lotteryId}', data.lottery)
      // .replace('{startDate}', data.startDate)
      // .replace('{endDate}', data.endDate)
      null
    );
  }

  fetchSpousePanDetailsService(data: any) {
    console.log(">>>>>>>>>>>>>>>>>>>the Application number is >", data);
    return this.httpClient.get<any>(
      ApiUrls.fetchSpousePanDetailsURLs.replace(
        "{applicationNo}",
        data.applicationNo
      )
    );
  }

  fetchSelfAadharDetailsService(data: any) {
    console.log(">>>>>>>>>>>>>>>>>>>the Application number is >", data);
    return this.httpClient.get<any>(
      ApiUrls.fetchSelfAadharUpdateURLs.replace(
        "{applicationNo}",
        data.applicationNo
      )
    );
  }

  fetchAadharBackPhotoService(data: any) {
    console.log(">>>>>>>>>>>>>>>>>>>the Application number is >", data);
    return this.httpClient.get<any>(
      ApiUrls.fetchAadharBackPhotoServiceURLs.replace(
        "{applicationNo}",
        data.applicationNo
      )
    );
  }

  updateSpousePanDetailsService(file: PanFileResponseModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateSpousePanDetails}`,
      file
    );
  }

  changeAadharPhotoService(file: PanFileResponseModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.changeAadharPhotoURLs}`,
      file
    );
  }

  fetchSpouseAadharDetailsService(data: any) {
    console.log(">>>>>>>>>>>>>>>>>>>the Application number is >", data);
    return this.httpClient.get<any>(
      ApiUrls.fetchSpouseAadharUpdateURLs.replace(
        "{applicationNo}",
        data.applicationNo
      )
    );
  }

  fetchSpouseAadharBackPhotoService(data: any) {
    console.log(">>>>>>>>>>>>>>>>>>>the Application number is >", data);
    return this.httpClient.get<any>(
      ApiUrls.fetchSpouseAadharBackPhotoServiceURLs.replace(
        "{applicationNo}",
        data.applicationNo
      )
    );
  }

  changeApplicantAadharPhotoService(file: PanFileResponseModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.changeApplicantAadharPhotoURLs}`,
      file
    );
  }

  fetchApplicantMobileNumberService(data: any) {
    console.log(">>>>>>>>>>>>>>>>>>>the Application number is >", data);
    return this.httpClient.get<any>(
      ApiUrls.fetchApplicantMobileNumberServiceURLs.replace(
        "{applicationNo}",
        data.applicationNo
      )
    );
  }

  updateApplicationMobileNumberService(
    file: ApplicantMobileNumberAndEmailModel
  ) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateApplicationMobileNumberURLs}`,
      file
    );
  }

  fetchApplicantEmailService(data: any) {
    console.log(">>>>>>>>>>>>>>>>>>>the Application number is >", data);
    return this.httpClient.get<any>(
      ApiUrls.fetchApplicantEmailServiceURLs.replace(
        "{applicationNo}",
        data.applicationNo
      )
    );
  }

  updateApplicationEmailIdService(file: ApplicantMobileNumberAndEmailModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateApplicationEmailIdServiceURLs}`,
      file
    );
  }

  
  fetchSpouseEmailIdService(data: any) {
    console.log(">>>>>>>>>>>>>>>>>>>the Application number is >", data);
    return this.httpClient.get<any>(
      ApiUrls.fetchSpouseEmailIdServiceURLs.replace(
        "{applicationNo}",
        data.applicationNo
      )
    );
  }

  updateSpouseEmailIdService(file: ApplicantMobileNumberAndEmailModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateSpouseEmailIdServiceURLs}`,
      file
    );
  }

  // changeBoard(data: any) {
  //   // console.log(data);
  //   return this.httpClient.get(
  //     ApiUrls.getProjectDetails.replace("{boardId}", data)
  //   );
  // }

  changeLottery(data:any){
    console.log(data);
    return this.httpClient.get(ApiUrls.changeBoardURLs.replace('{boardId}',data));
  }

  changePmayLottery(data:any){
    console.log(data);
    return this.httpClient.get(ApiUrls.changeBoardForPmayLotteryURLs.replace('{boardId}',data));
  }

  //corrigendum Letter Download

uploadCorresponceDocService(file: UploadCorrespondence) { 
  return this.httpClient.post<{status:string; successMsg:string; errorMessage:string}>
    (`${ApiUrls.uploadCorresponceDocServiceURLs}`,file);
}
  

changeBoard(data:any){
  console.log(data);
  return this.httpClient.get(ApiUrls.changeBoardURLs.replace('{boardId}',data));
}

//corrigendum Letter Download

downloadCorrigendumLetter( applicationNo: string) {
  return this.httpClient.post<FileResponseModel>(
      ApiUrls.downloadCorrigendumLetterUrl
      .replace('{applicationNo}', applicationNo)
     , null);
}  


downloadCorrespondanceLetter( applicationNo: string) {
  return this.httpClient.post<FileResponseModel>(
      ApiUrls.downloadCorrespondanceLetterUrl
      .replace('{applicationNo}', applicationNo)
     , null);
}  

downloadNomineeDocFile( applicationNo: string) {
  return this.httpClient.post<FileResponseModel>(
      ApiUrls.downloadNomineeDocFileLetterUrl
      .replace('{applicationNo}', applicationNo)
     , null);
}  

downloadNomineeOrderFile( applicationNo: string) {
  return this.httpClient.post<FileResponseModel>(
      ApiUrls.downloadNomineeOrderFileLetterUrl
      .replace('{applicationNo}', applicationNo)
     , null);
}  

  getProfileDetails(panNumber: any): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("panNumber", panNumber.toUpperCase());
    return this.httpClient
      .post<any>(serverUrl + "open/getProfileDetailsByPan", queryParams, {
        headers: new HttpHeaders().set(
          "Content-Type",
          "application/x-www-form-urlencoded;charset=utf-8"
        ),
      })
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          return throwError(err);
        }),
        catchError((err) => {
          return of(err);
        })
      );
  }

  getSchemeNameService(data: any) {
    console.log(data);
    return this.httpClient.get(
      ApiUrls.fetchSchemeListURLs.replace("{lotteryId}", data)
    );
  }

  DownloadEBillingReportURLs(data: EBillingReportModal) {
    console.log(data);
    // return this.httpClient.post<FileResponseModel>(
    //     ApiUrls.DownloadEBillingReportURLs
    //     .replace('{boardId}', data.board)
    //     .replace('{lotteryId}', data.lottery)
    //     .replace('{startDate}', data.startDate)
    //     .replace('{endDate}', data.endDate)
    //    , null);
    return this.httpClient.post<{
      data: string;
      status: string;
      fileName: string;
      errorMessage: string;
    }>(`${ApiUrls.DownloadEBillingReportURLs}`, data);
  }

  downloadFile(documentPath: any): Observable<any> {
    // const formData = new FormData();
    // formData.append("documentPath", documentPath);
    // const url = (await serverUrl) + "downloadFile";
    // return new Promise((resolve) => {
    //   this.httpClient
    //     .post(url, formData, { responseType: "arraybuffer" as "json" })
    //     .toPromise()
    //     .then((res) => {
    //       resolve(res);
    //     })
    //     .catch((resp: Response) => {
    //       resolve(resp);
    //     });
    // });
    let queryParams = new HttpParams();
    queryParams = queryParams.append("documentPath", documentPath);
    return this.httpClient
      .post<any>(serverUrl + "open/downloadDocFile", queryParams, {
        responseType: "arraybuffer" as "json",
        headers: new HttpHeaders().set(
          "Content-Type",
          "application/x-www-form-urlencoded;charset=utf-8"
        ),
      })
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          return throwError(err);
        }),
        catchError((err) => {
          return of(err);
        })
      );
  }

  fetchRejectedSelfAadharDetailsService(data: any) {
    console.log(">>>>>>>>>>>>>>>>>>>the Application number is >", data);
    return this.httpClient.get<any>(
      ApiUrls.fetchRejectedSelfAadharUpdateURLs.replace(
        "{applicationNo}",
        data.applicationNo
      )
    );
  }

  fetchRejectedAadharBackPhotoService(data: any) {
    console.log(">>>>>>>>>>>>>>>>>>>the Application number is >", data);
    return this.httpClient.get<any>(
      ApiUrls.fetchRejectedAadharBackPhotoServiceURLs.replace(
        "{applicationNo}",
        data.applicationNo
      )
    );
  }

  changeRejectedAadharPhotoService(file: PanFileResponseModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.changeRejectedAadharPhotoURLs}`,
      file
    );
  }
}
